<script setup lang="ts">
interface Feature {
  n: string
  title: string
  desc: string
  m: string
  u: string
}

const features: Feature[] = [
  {
    n: '01',
    title: 'Cena wiążąca w 8 minut',
    desc: 'Konfigurator liczy w czasie rzeczywistym. Nie ma „wycenimy do jutra" — kwota, którą widzisz, znajdzie się w umowie.',
    m: '8',
    u: 'minut',
  },
  {
    n: '02',
    title: 'Realizacja od 14 dni',
    desc: 'Standardowe konfiguracje robimy w dwa tygodnie. Niestandardowe pokazują czas już w konfiguratorze.',
    m: '14',
    u: 'dni',
  },
  {
    n: '03',
    title: 'Gwarancja 5 lat na zabudowę',
    desc: 'Pełna gwarancja na konstrukcję, izolację i okucia. Serwis mobilny w całej Polsce.',
    m: '5',
    u: 'lat',
  },
  {
    n: '04',
    title: 'Wsparcie 24/7',
    desc: 'Telefon do dyżurnego serwisanta otrzymujesz przy odbiorze. Średni czas reakcji — 23 minuty.',
    m: '24/7',
    u: 'dyżur',
  },
  {
    n: '05',
    title: 'Certyfikat ISO 9001',
    desc: 'Procesy audytowane od 2014 roku. Każda zabudowa przechodzi 38-punktową kontrolę przed wydaniem.',
    m: '38',
    u: 'kontroli',
  },
]
</script>

<template>
  <section
    class="border-pw-ink text-pw-paper relative border-b bg-[#faf7f0] px-5 py-16 md:px-14 md:py-24"
  >
    <div class="mx-auto max-w-[1440px]">
      <div class="features-grid grid items-start gap-16">
        <div>
          <div
            class="text-pw-muted mb-6 font-mono text-[12px] font-semibold tracking-[0.14em]"
          >
            [ 03 / DLACZEGO MY ]
          </div>
          <h2
            class="font-narrow m-0 mb-6 text-[clamp(48px,6vw,84px)] leading-[0.95] font-extrabold tracking-[-0.02em]"
          >
            Robimy to, co<br />obiecujemy
            <em
              class="bg-pw-orange text-pw-ink -mx-1 inline-block px-3 not-italic"
              >— na czas</em
            >.
          </h2>
          <p
            class="text-pw-dim m-0 mb-8 max-w-[460px] text-[17px] leading-[1.5]"
          >
            Od 2009 roku zbudowaliśmy ponad 4 200 zabudów. Konfigurator pokazuje
            tylko realne opcje, a kalkulacja jest wiążąca. Bez gwiazdek pod
            tabelą.
          </p>
          <a
            href="#"
            class="bg-pw-paper text-pw-ink hover:bg-pw-paper-2 inline-flex cursor-pointer items-center gap-2.5 rounded-[2px] px-7 py-[18px] text-[16px] font-semibold no-underline transition-all"
          >
            Zobacz realizacje
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </a>
        </div>

        <div class="border-pw-muted flex flex-col border-t">
          <div
            v-for="f in features"
            :key="f.n"
            class="border-pw-ink grid grid-cols-[56px_1fr_auto] items-start gap-5 border-b py-5"
          >
            <div class="text-pw-muted pt-1 font-mono text-[12px]">
              {{ f.n }}
            </div>
            <div>
              <h4
                class="font-narrow m-0 mb-1 text-[22px] font-bold tracking-tight"
              >
                {{ f.title }}
              </h4>
              <p
                class="text-pw-dim m-0 max-w-[420px] text-[14px] leading-[1.5]"
              >
                {{ f.desc }}
              </p>
            </div>
            <div
              class="font-narrow text-right text-[32px] leading-none font-extrabold tracking-tight"
            >
              {{ f.m }}
              <small
                class="text-pw-muted mt-1 block font-mono text-[10px] font-medium tracking-[0.1em] uppercase"
                >{{ f.u }}</small
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.features-grid {
  grid-template-columns: 1.2fr 1fr;
}

@media (max-width: 1100px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
}
</style>
